/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_1_4a = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [23.722471736948194, 38.027334061659424],
                        [23.70783760456294, 38.027334061659424],
                        [23.70783760456294, 38.016819907520635],
                        [23.722471736948194, 38.016819907520635],
                        [23.722471736948194, 38.027334061659424]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_1_4a